module.exports = __webpack_public_path__ + "static/media/badge-green.a00f0149.svg";